<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

definePage({
  redirect: '/manage/events',
  // Inherited by every /manage child. Without it /manage, /manage/create and
  // /manage/events carry no auth meta at all, while groups and rules declare
  // their own.
  meta: {
    requiresAuth: true,
  },
})

const route = useRoute()
const { t } = useI18n()

interface ManageTab {
  routeName: '/manage/events/' | '/manage/groups' | '/manage/rules'
  to: string
  label: string
  icon: string
}

const items = computed<ManageTab[]>(() => {
  return [
    {
      routeName: '/manage/events/',
      to: '/manage/events',
      label: t('router.pages.workspaces-id-events'),
      icon: 'i-lucide-book',
    },
    {
      routeName: '/manage/groups',
      to: '/manage/groups',
      label: t('router.pages.workspaces-id-groups'),
      icon: 'i-lucide-users',
    },
    {
      routeName: '/manage/rules',
      to: '/manage/rules',
      label: t('router.pages.manage-rules'),
      icon: 'i-lucide-shield',
    },
  ]
})

const activeTab = computed(
  () =>
    items.value.find((item) => String(route.name ?? '').includes(item.routeName))?.routeName ||
    '/manage/events/',
)
const isOnOneOfTabs = computed(() =>
  ['/manage/events/', '/manage/groups', '/manage/rules', '/manage'].includes(route.name as string),
)
</script>

<template>
  <AppTabs v-if="isOnOneOfTabs" :value="activeTab">
    <AppTabList>
      <AppTab v-for="tab in items" :key="tab.label" :value="tab.routeName" :to="tab.to">
        <UIcon :name="tab.icon" />
        <span>{{ tab.label }}</span>
      </AppTab>
    </AppTabList>
  </AppTabs>
  <router-view />
</template>
